// Template250: Bélgica - Día 2 Amberes mapa + cómo llegar + más rincones (Page7.jsx)
// Mapa iframe + 2 tips + 2 stickers, Cómo llegar, 2 SabiasQue, lista data.lugares.

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template250 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	const headerText = page?.texts?.[0]?.content;
	const tipLeft = page?.texts?.[1]?.content;
	const tipRight = page?.texts?.[2]?.content;
	const comoLlegarTitle = page?.texts?.[3]?.content;
	const comoLlegarBody = page?.texts?.[4]?.content;
	const rinconesTitle = page?.texts?.[5]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerCalle = getImageSrc("sticker") || getImageSrc("sticker-calle");
	const stickerCerveza =
		getImageSrc("sticker2") || getImageSrc("sticker-cerveza");
	const logoImage = getCanvasImageUrl("logo");
	const mapUrl = page?.maps?.[0] || "";

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const lugares = Array.isArray(page?.data?.lugares) ? page.data.lugares : [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: actualHeaderColor,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa Amberes"
					src={mapUrl}
					width="100%"
					height="100%"
					style={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				overflow: "auto",
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Mapa: en móvil altura fija para que se vea bien; en desktop flex para rellenar */}
			<Box
				data-block-id="map"
				sx={{
					position: "relative",
					marginTop: "-70px",
					overflow: "hidden",
					...(isSmallScreen
						? { minHeight: "420px", height: "420px", flexShrink: 0 }
						: { flex: 1, minHeight: 0 }),
				}}
			>
				{tipLeft && (
					<Box
						sx={{
							position: "absolute",
							bottom: 60,
							left: 20,
							backgroundColor: "#fff8db",
							border: "2px solid #D4A017",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: "11px",
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 120,
							zIndex: 6,
						}}
					>
						{tipLeft}
					</Box>
				)}
				{stickerCalle && (
					<Box
						component="img"
						src={stickerCalle}
						alt=""
						sx={{
							width: 110,
							position: "absolute",
							bottom: -10,
							left: -20,
							zIndex: 5,
						}}
					/>
				)}
				{tipRight && (
					<Box
						sx={{
							position: "absolute",
							bottom: 60,
							right: 20,
							backgroundColor: "#fff8db",
							border: "2px solid #D4A017",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: "11px",
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 120,
							zIndex: 6,
						}}
					>
						{tipRight}
					</Box>
				)}
				{stickerCerveza && (
					<Box
						component="img"
						src={stickerCerveza}
						alt=""
						sx={{
							width: 110,
							position: "absolute",
							bottom: -10,
							right: -20,
							zIndex: 5,
						}}
					/>
				)}

				{mapUrl && (
					<>
						<iframe
							title="Mapa Amberes"
							src={mapUrl}
							width="100%"
							height={isSmallScreen ? "420px" : "100%"}
							style={{
								border: 0,
								display: "block",
							}}
						/>
						<button
							onClick={() => setFullscreen(true)}
							style={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: actualHeaderColor,
								color: "#fff",
								padding: "6px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								fontFamily: "'Poppins', sans-serif",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</button>
					</>
				)}
			</Box>

			{/* Cómo llegar */}
			<Box data-block-id="text-1" sx={{ padding: "12px 12px 8px", position: "relative" }}>
				{sabiasQue[0] && (
					<Box sx={{ position: "absolute", top: -10, left: "32%" }}>
						<SabiasQue icono={sabiasQue[0].icono} texto={sabiasQue[0].texto} />
					</Box>
				)}
				{sabiasQue[1] && (
					<Box sx={{ position: "absolute", top: -10, left: "42%" }}>
						<SabiasQue icono={sabiasQue[1].icono} texto={sabiasQue[1].texto} />
					</Box>
				)}
				<Box
					sx={{
						backgroundColor: "#fef9e6",
						border: "2px solid #D4A017",
						borderRadius: "12px",
						padding: "12px 14px",
						fontSize: "13px",
						color: "#333",
					}}
				>
					{comoLlegarTitle && (
						<Box
							component="h4"
							sx={{
								margin: 0,
								marginBottom: "8px",
								fontSize: "14px",
								fontWeight: 700,
								color: "#8b6914",
								textTransform: "uppercase",
							}}
						>
							{comoLlegarTitle}
						</Box>
					)}
					{comoLlegarBody && (
						<Box component="p" sx={{ margin: 0, lineHeight: 1.5, ...estiloP }}>
							{comoLlegarBody}
						</Box>
					)}
				</Box>
			</Box>

			{/* Más rincones */}
			<Box data-block-id="text-2" sx={{ padding: "0 12px 16px" }}>
				<Box
					sx={{
						backgroundColor: "#f9ebc8",
						border: "2px solid #D4A017",
						borderRadius: "12px",
						padding: "12px 14px",
						color: "#333",
					}}
				>
					{rinconesTitle && (
						<Box
							component="h4"
							sx={{
								margin: 0,
								marginBottom: "12px",
								fontSize: "14px",
								fontWeight: 700,
								color: "#8b6914",
								textTransform: "uppercase",
							}}
						>
							{rinconesTitle}
						</Box>
					)}
					<Box
						component="ul"
						sx={{
							margin: 0,
							display: "flex",
							flexDirection: "column",
							gap: "10px",
							paddingLeft: isSmallScreen ? "10px" : "20px",
						}}
					>
						{lugares.map((item, index) => (
							<Box
								component="li"
								key={index}
								sx={{
									fontSize: "12px",
									lineHeight: 1.45,
									color: "#444",
									marginBottom: "2px",
								}}
							>
								<Box component="strong" sx={{ color: "#8b6914" }}>
									{item.titulo}
								</Box>
								{": "}
								{item.texto}
							</Box>
						))}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template250.thumbnail = "/images/template-1.png";
export default Template250;
